<template>
  <router-view />
</template>

<script>
export default {
  name: "Personnel",
};
</script>

<style>
</style>